import { render } from "./ProductBox.vue?vue&type=template&id=155f27bb&scoped=true&ts=true"
import script from "./ProductBox.vue?vue&type=script&lang=ts"
export * from "./ProductBox.vue?vue&type=script&lang=ts"

import "./ProductBox.vue?vue&type=style&index=0&id=155f27bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155f27bb"]])

export default __exports__